"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPERTY_CARD_BADGE_APPEARANCES = void 0;
var PROPERTY_CARD_BADGE_APPEARANCES = Object.freeze({
  DEFAULT: 'default',
  NOTIFICATION: 'notification',
  ZILLOW: 'zillow'
});
exports.PROPERTY_CARD_BADGE_APPEARANCES = PROPERTY_CARD_BADGE_APPEARANCES;